import axios from 'axios';
import React, { useEffect, useState } from 'react';
import NewsItem from './NewsItem';
import { Button, Box, CircularProgress } from '@mui/material';

const News = () => {
  const [currentPages, setCurrentPages] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axios
      .get(`/api/v1/posts`, {
        params: {
          page: currentPages,
          limit: 9,
          isFooter: false,
        },
      })
      .then((res) => {
        setData(res.data.posts);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const handleViewMore = () => {
    setLoading(true);
    setCurrentPages(currentPages + 1);
    axios
      .get(`/api/v1/posts`, {
        params: {
          page: currentPages + 1,
          limit: 9,
          isFooter: false,
        },
      })
      .then((res) => {
        setData((prevData) => [...prevData, ...res.data.posts]);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="login-signup-container mt-4">
        <div className="contact-title">Tin tức</div>

        <div className="news-layout">
          <div className="news-layout-content">
            {data.map((item, idx) => (
              <NewsItem data={item} key={idx} />
            ))}
          </div>
          {currentPages < totalPages && (
            <div className="news-layout-view-more">
              <Button
                variant="contained"
                size="large"
                onClick={handleViewMore}
                sx={{ pl: 5, pr: 5, backgroundColor: '#0148b7' }}
              >
                Xem thêm
              </Button>
            </div>
          )}
        </div>
      </div>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: '#0184b7' }} />
        </Box>
      )}
    </>
  );
};

export default News;
